import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* inviteMember({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.invitations.invite, data: values });
    yield put(actions.inviteMemberDone(data.result));

    onSuccess();
    yield put(actions.inviteMemberDone({}));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.inviteMemberFailed,
      handledErrors,
      endpoint: api.invitations.invite.url
    });
  }
}

export const inviteMemberSaga = takeEvery(types.INVITE_MEMBER_REQUEST, inviteMember);